/**
 * Where a portaled layer (a dialog, a toast, a menu) is drawn: inside the app
 * shell, where the visual style's colours and type apply, never the bare
 * document body. Drawn on the body, the chord inspector, the toasts and the
 * Band panel's sound menus all fell back to the stylesheet's root palette:
 * the old teal accent and a sans face (user-found, Oct 2026: "the play button
 * is green", "the toast is green text"). The body stays the fallback for a
 * component rendered without the shell (a unit test).
 */
export function shellHost(): HTMLElement {
  return document.querySelector<HTMLElement>('.app-shell') ?? document.body;
}
